import { createEnumeratorAttrMap, IEnumeratorModel } from "./IEnumeratorModel";

export type IDruhZadavacihoRizeni = IEnumeratorModel;
export const DruhZadavacihoRizeniAttrMap = createEnumeratorAttrMap('Druh_zadavac_rizeni');
